module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [(_vm.userRole !== _vm.rootRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('div', [_c('v-btn', {
    staticClass: "teal lighten-1 white--text",
    attrs: {
      "small": "",
      "depressed": "",
      "id": "viewer-permission-edit-btn"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startDialog($event)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('viewable-locations.button-add-viewable-locations')) + "\n  ")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-form', {
    ref: "viewerPermissionForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "px-0 py-2",
    attrs: {
      "xs9": ""
    }
  }, [_c('v-subheader', {}, [_vm._v(_vm._s(_vm.$t("viewable-locations.label-viewing-target-locations")))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('viewable-locations.label-viewing-target-locations'),
      "items": _vm.locations,
      "item-text": "locationName",
      "item-value": "locationId",
      "multiple": "",
      "max-height": "300",
      "hint": _vm.$t('viewable-locations.hint-viewing-target-locations'),
      "persistent-hint": ""
    },
    model: {
      value: (_vm.edit.accountGroupResourceIds.viewLocation),
      callback: function($$v) {
        _vm.$set(_vm.edit.accountGroupResourceIds, "viewLocation", $$v)
      },
      expression: "edit.accountGroupResourceIds.viewLocation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('viewable-locations.button-cancel')) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setVisibleLocations($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('viewable-locations.button-set')) + "\n            ")])], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-0aae6a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountVisibleLocationsSetDialog.vue
// module id = 1907
// module chunks = 0